export const createDropdownValuesSlice = (set) => ({
  dropdownValues: [],
  storeDropdownValues: (values) => set({ dropdownValues: values }),
  clearDropdownValues: () => set({ dropdownValues: [] }),
});
